<ng-template #headerContent> <ng-content></ng-content> </ng-template>
